import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, CardFooter, CardHeading } from '@components/layout/Card'

// The security page itself lives at a role-agnostic route so paraplanners and
// the other profiles without a settings screen can reach it too. This card is
// only here so wealth managers find it where they already look.
export const SecuritySettingsCard = ({ securitySettingsPath }) => (
  <Card>
    <CardHeading>
      <h5>Security</h5>
    </CardHeading>
    <CardContent>
      <p>
        Choose how we check it is you when you sign in — a one time pin by SMS, or a code from an
        authenticator app such as 1Password or Authy.
      </p>
    </CardContent>
    <CardFooter>
      <a href={securitySettingsPath}>Manage two factor authentication</a>
    </CardFooter>
  </Card>
)

SecuritySettingsCard.propTypes = {
  securitySettingsPath: PropTypes.string.isRequired,
}
